import { render, staticRenderFns } from "./OptionConfig.vue?vue&type=template&id=753409ee&scoped=true"
import script from "./OptionConfig.vue?vue&type=script&lang=js"
export * from "./OptionConfig.vue?vue&type=script&lang=js"
import style0 from "./OptionConfig.vue?vue&type=style&index=0&id=753409ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753409ee",
  null
  
)

export default component.exports